import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../styles/public.css';

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);
  const btn = { display:'inline-flex',alignItems:'center',justifyContent:'center',gap:8,padding:'10px 20px',borderRadius:'var(--radius-sm)',fontFamily:'inherit',fontSize:'0.9rem',fontWeight:600,textDecoration:'none',border:'none',cursor:'pointer' };
  const btnP = { ...btn, background:'var(--accent)', color:'var(--primary)' };
  const btnO = { ...btn, background:'transparent', color:'var(--primary)', border:'1.5px solid var(--border)' };
  const NAV_LINKS = [{ href:'/api', label:'API' },{ href:'/#precos', label:'Preços' },{ href:'/sobre', label:'Empresa' },{ href:'/ajuda', label:'Suporte' }];
  return (
    <nav style={{ position:'fixed',top:0,left:0,right:0,zIndex:1000,padding:scrolled?'12px 0':'16px 0',background:(scrolled||mobileMenu)?'rgba(255,255,255,0.95)':'transparent',backdropFilter:(scrolled||mobileMenu)?'blur(20px)':'none',borderBottom:(scrolled||mobileMenu)?'1px solid var(--border)':'none',transition:'all 0.4s' }}>
      <div className="container" style={{ display:'flex',alignItems:'center',justifyContent:'space-between' }}>
        <Link to="/" style={{ display:'flex',alignItems:'center',gap:10,textDecoration:'none',fontWeight:700,fontSize:'1.3rem',color:'var(--primary)' }}>
          <div style={{ width:36,height:36,background:'var(--primary)',borderRadius:6,display:'flex',alignItems:'center',justifyContent:'center',color:'var(--accent)',fontWeight:700,fontSize:'1.1rem' }}>S</div>
          SimulaBank
        </Link>
        <div className="desk-nav" style={{ display:'flex',alignItems:'center',gap:28 }}>
          {NAV_LINKS.map(({href,label}) => <Link key={href} to={href} style={{ textDecoration:'none',color:'var(--text-muted)',fontSize:'0.9rem',fontWeight:500 }}>{label}</Link>)}
        </div>
        <div className="desk-btns" style={{ display:'flex',gap:12,alignItems:'center' }}>
          <Link to="/login" style={btnO}>Entrar</Link>
          <Link to={`https://wa.me/5561991826667?text=${encodeURIComponent('Começar grátis')}`} target="_blank" rel="noopener noreferrer" style={btnP}>Começar grátis</Link>
        </div>
        <button className="mob-toggle" onClick={() => setMobileMenu(!mobileMenu)} style={{ display:'none',flexDirection:'column',gap:4.5,background:'none',border:'none',cursor:'pointer',padding:8 }}>
          {[0,1,2].map(i => <span key={i} style={{ display:'block',width:22,height:2,borderRadius:1,background:'var(--primary)',transition:'all 0.3s',...(i===0&&mobileMenu?{transform:'rotate(45deg) translate(4.5px,4.5px)'}:{}),...(i===1&&mobileMenu?{opacity:0}:{}),...(i===2&&mobileMenu?{transform:'rotate(-45deg) translate(4.5px,-4.5px)'}:{}) }} />)}
        </button>
      </div>
      {mobileMenu && (
        <div className="mob-menu" style={{ display:'flex',flexDirection:'column',padding:'12px 24px 20px',background:'rgba(255,255,255,0.98)',borderTop:'1px solid var(--border)' }}>
          {NAV_LINKS.map(({href,label}) => <Link key={href} to={href} onClick={() => setMobileMenu(false)} style={{ textDecoration:'none',color:'var(--text)',fontSize:'0.95rem',fontWeight:500,padding:'12px 0',borderBottom:'1px solid var(--border)' }}>{label}</Link>)}
          <div style={{ display:'flex',gap:10,marginTop:16 }}>
            <Link to="/login" style={{ ...btnO,flex:1,textAlign:'center',justifyContent:'center' }}>Entrar</Link>
            <Link to="/cadastro" style={{ ...btnP,flex:1,textAlign:'center',justifyContent:'center' }}>Começar grátis</Link>
          </div>
        </div>
      )}
    </nav>
  );
}

function Footer() {
  const COLS = [
    { title:'Produto', links:[{l:'Funcionalidades',h:'/#features'},{l:'Preços',h:'/#precos'},{l:'API',h:'/api'},{l:'Changelog',h:'/changelog'}] },
    { title:'Empresa', links:[{l:'Sobre',h:'/sobre'},{l:'Blog',h:'/blog'},{l:'Contato',h:'/contato'},{l:'Carreiras',h:'/carreiras'}] },
    { title:'Suporte', links:[{l:'Central de ajuda',h:'/ajuda'},{l:'Documentação',h:'/docs'},{l:'Status',h:'/status'},{l:'WhatsApp',h:'/whatsapp'}] },
  ];
  return (
    <footer style={{ padding:'60px 0 32px',borderTop:'1px solid var(--border)' }}>
      <div className="container">
        <div className="footer-grid" style={{ marginBottom:48 }}>
          <div>
            <Link to="/" style={{ display:'flex',alignItems:'center',gap:10,textDecoration:'none',fontWeight:700,fontSize:'1.3rem',color:'var(--primary)' }}>
              <div style={{ width:36,height:36,background:'var(--primary)',borderRadius:6,display:'flex',alignItems:'center',justifyContent:'center',color:'var(--accent)',fontWeight:700,fontSize:'1.1rem' }}>S</div>
              SimulaBank
            </Link>
            <p style={{ color:'var(--text-muted)',fontSize:'0.88rem',marginTop:12,maxWidth:280,lineHeight:1.6 }}>A ferramenta definitiva para simulação e comparação de financiamento imobiliário entre múltiplos bancos.</p>
          </div>
          {COLS.map(col => (
            <div key={col.title}>
              <h4 style={{ fontSize:'0.8rem',fontWeight:600,textTransform:'uppercase',letterSpacing:'0.1em',color:'var(--text-muted)',marginBottom:16 }}>{col.title}</h4>
              {col.links.map(({l,h}) => <Link key={l} to={h} style={{ display:'block',color:'var(--text)',textDecoration:'none',fontSize:'0.9rem',padding:'4px 0' }}>{l}</Link>)}
            </div>
          ))}
        </div>
        <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',paddingTop:24,borderTop:'1px solid var(--border)',fontSize:'0.82rem',color:'var(--text-muted)',flexWrap:'wrap',gap:12 }}>
          <span>© 2026 SimulaBank. Todos os direitos reservados.</span>
          <div style={{ display:'flex',gap:24 }}>
            {['Termos de uso','Privacidade','LGPD'].map(l => <a key={l} href="#" style={{ color:'var(--text-muted)',textDecoration:'none' }}>{l}</a>)}
          </div>
        </div>
      </div>
    </footer>
  );
}

function useReveal() {
  const revealRefs = useRef([]);
  const addReveal = el => { if (el && !revealRefs.current.includes(el)) revealRefs.current.push(el); };
  const revealStyle = { opacity:0, transform:'translateY(24px)', transition:'all 0.7s cubic-bezier(0.16,1,0.3,1)' };
  useEffect(() => {
    const obs = new IntersectionObserver(entries => entries.forEach(e => { if (e.isIntersecting) { e.target.style.opacity='1'; e.target.style.transform='translateY(0)'; } }), { threshold:0.08 });
    revealRefs.current.forEach(el => el && obs.observe(el));
    return () => obs.disconnect();
  }, []);
  return { addReveal, revealStyle };
}

/* ════════════════════════════════════════════════════════════
   PAGE: CENTRAL DE AJUDA
════════════════════════════════════════════════════════════ */
const FAQ_CATEGORIES = [
  {
    icon:'🚀', title:'Primeiros passos',
    items:[
      { q:'Como criar minha conta no SimulaBank?', a:'Acesse simulabank.com.br/cadastro, preencha seus dados e confirme seu email. O trial de 7 dias começa automaticamente, sem cartão de crédito.' },
      { q:'Existe período de teste gratuito?', a:'Sim! Você tem 7 dias para testar todas as funcionalidades sem precisar de cartão de crédito. Ao final, escolha o plano que melhor se encaixa.' },
      { q:'Como faço minha primeira simulação?', a:'Acesse o painel, clique em "Nova simulação", preencha o valor do imóvel, valor financiado, prazo e data de nascimento do cliente. Em segundos você terá o comparativo dos 6 bancos.' },
    ]
  },
  {
    icon:'🏦', title:'Simulações e cálculos',
    items:[
      { q:'Quais bancos são suportados?', a:'BRB, Santander, Itaú, Inter, Bradesco e Caixa Econômica Federal. Todos com cálculos SAC calibrados com as tabelas oficiais de cada instituição.' },
      { q:'Os cálculos batem com os simuladores oficiais dos bancos?', a:'Sim. Nossos cálculos são reverse-engineered dos simuladores oficiais de cada banco, incluindo as regras de MIP, DFI e TGC. Qualquer divergência deve ser reportada para nosso time.' },
      { q:'O que é MIP e DFI no financiamento?', a:'MIP (Morte e Invalidez Permanente) e DFI (Danos Físicos ao Imóvel) são seguros obrigatórios no financiamento imobiliário. O SimulaBank calcula ambos automaticamente com base na idade do mutuário e no valor financiado.' },
      { q:'Como o CET é calculado?', a:'O CET (Custo Efetivo Total) inclui taxa de juros, seguros MIP e DFI, tarifas de abertura e outras despesas. O SimulaBank calcula o CET anual conforme regulamentação do Banco Central.' },
    ]
  },
  {
    icon:'📄', title:'PDF e exportação',
    items:[
      { q:'Como personalizar o PDF com minha marca?', a:'Vá em Configurações > Identidade visual. Você pode fazer upload do seu logotipo, definir cores primárias e adicionar informações da sua empresa.' },
      { q:'Posso enviar o PDF diretamente ao cliente?', a:'Sim. Após gerar o PDF, você pode compartilhar via link direto ou fazer download para enviar por WhatsApp ou email.' },
      { q:'O PDF inclui a tabela completa de parcelas?', a:'Sim. O relatório inclui o comparativo resumido entre bancos e, ao clicar em um banco, você pode gerar o PDF com a tabela completa mês a mês.' },
    ]
  },
  {
    icon:'🔗', title:'Integrações e CRM',
    items:[
      { q:'Como integrar com o Bitrix24?', a:'No plano Simulador + Seu CRM, acesse Configurações > Integrações > Bitrix24. Você precisará do URL do seu Bitrix24 e de um webhook de autenticação.' },
      { q:'A integração funciona com o HubSpot e Pipedrive?', a:'Sim. Suportamos Bitrix24, HubSpot e Pipedrive nos planos de integração. Cada simulação pode ser vinculada a um deal/negócio do seu CRM.' },
      { q:'Posso usar via API?', a:'A API está em desenvolvimento. Cadastre-se na lista de espera em simulabank.com.br/api para ser notificado quando entrar em beta.' },
    ]
  },
  {
    icon:'💳', title:'Planos e faturamento',
    items:[
      { q:'Como funciona o limite de simulações?', a:'O plano Simulador inclui 100 simulações/mês. O plano Simulador + CRM inclui 200. O plano completo tem simulações ilimitadas. Um contador é exibido no painel.' },
      { q:'Posso cancelar a qualquer momento?', a:'Sim, sem multa ou carência. Ao cancelar, você mantém acesso até o fim do período faturado.' },
      { q:'Há desconto para pagamento anual?', a:'Sim. Pagando anualmente você tem 20% de desconto em relação ao plano mensal.' },
    ]
  },
];

export function AjudaPage() {
  const { addReveal, revealStyle } = useReveal();
  const [search, setSearch] = useState('');
  const [openCat, setOpenCat] = useState(0);
  const [openItem, setOpenItem] = useState(null);

  const filteredCats = FAQ_CATEGORIES.map(cat => ({
    ...cat,
    items: cat.items.filter(item =>
      !search || item.q.toLowerCase().includes(search.toLowerCase()) || item.a.toLowerCase().includes(search.toLowerCase())
    )
  })).filter(cat => cat.items.length > 0);

  return (
    <div className="sb-page">
      <Navbar />

      {/* ── HERO ── */}
      <section style={{ padding:'160px 0 80px',background:'var(--surface)',position:'relative',overflow:'hidden' }}>
        <div style={{ position:'absolute',top:-200,right:-100,width:600,height:600,background:'radial-gradient(circle, rgba(0,214,143,0.06) 0%, transparent 65%)',pointerEvents:'none' }} />
        <div className="container" style={{ position:'relative',zIndex:1,textAlign:'center',maxWidth:680,margin:'0 auto' }}>
          <span className="section-label" style={{ justifyContent:'center' }}>Central de ajuda</span>
          <h1 className="serif page-title" style={{ fontSize:'3.2rem',marginBottom:20 }}>Como podemos <em>ajudar?</em></h1>
          <p style={{ color:'var(--text-muted)',fontSize:'1.05rem',marginBottom:36 }}>Encontre respostas rápidas ou fale com nossa equipe.</p>
          <div style={{ position:'relative',maxWidth:520,margin:'0 auto' }}>
            <span style={{ position:'absolute',left:16,top:'50%',transform:'translateY(-50%)',fontSize:'1rem',pointerEvents:'none' }}>🔍</span>
            <input value={search} onChange={e => { setSearch(e.target.value); setOpenCat(0); setOpenItem(null); }} placeholder="Busque por palavra-chave, ex: PDF, MIP, cancelar..."
              style={{ width:'100%',padding:'16px 16px 16px 44px',borderRadius:'var(--radius)',border:'1.5px solid var(--border)',fontSize:'1rem',fontFamily:'inherit',outline:'none',boxSizing:'border-box',background:'#fff',boxShadow:'0 4px 20px rgba(0,0,0,0.06)',transition:'border-color 0.2s' }}
              onFocus={e => e.target.style.borderColor='var(--accent)'}
              onBlur={e => e.target.style.borderColor='var(--border)'} />
          </div>
        </div>
      </section>

      <section style={{ padding:'80px 0 120px' }}>
        <div className="container">
          <div className="ajuda-layout">
            {/* Sidebar categories */}
            <div ref={addReveal} style={{ ...revealStyle,position:'sticky',top:96 }}>
              <div style={{ background:'var(--surface)',borderRadius:'var(--radius)',border:'1px solid var(--border)',overflow:'hidden' }}>
                {FAQ_CATEGORIES.map((cat,i) => (
                  <button key={cat.title} onClick={() => { setOpenCat(i); setSearch(''); setOpenItem(null); }} style={{ width:'100%',display:'flex',alignItems:'center',gap:12,padding:'14px 18px',background:openCat===i?'var(--accent)':'transparent',color:openCat===i?'var(--primary)':'var(--text)',border:'none',borderBottom:i<FAQ_CATEGORIES.length-1?'1px solid var(--border)':'none',cursor:'pointer',fontFamily:'inherit',fontSize:'0.88rem',fontWeight:openCat===i?700:500,textAlign:'left',transition:'all 0.2s' }}>
                    <span>{cat.icon}</span>{cat.title}
                  </button>
                ))}
              </div>
              {/* Quick contacts */}
              <div style={{ marginTop:20,background:'var(--surface)',borderRadius:'var(--radius)',border:'1px solid var(--border)',padding:20 }}>
                <div style={{ fontSize:'0.78rem',fontWeight:700,textTransform:'uppercase',letterSpacing:'0.1em',color:'var(--text-muted)',marginBottom:14 }}>Suporte direto</div>
                {[{ icon:'💬', label:'WhatsApp', sub:'Resposta em 2h', href:'/whatsapp' },{ icon:'✉️', label:'Email', sub:'1 dia útil', href:'mailto:suporte@simulabank.com.br' }].map(c => (
                  <a key={c.label} href={c.href} style={{ display:'flex',alignItems:'center',gap:10,padding:'10px 0',textDecoration:'none',borderBottom:'1px solid var(--border)',color:'var(--text)' }}>
                    <span style={{ fontSize:'1.2rem' }}>{c.icon}</span>
                    <div>
                      <div style={{ fontWeight:600,fontSize:'0.88rem' }}>{c.label}</div>
                      <div style={{ fontSize:'0.75rem',color:'var(--text-muted)' }}>{c.sub}</div>
                    </div>
                  </a>
                ))}
              </div>
            </div>

            {/* FAQ accordion */}
            <div ref={addReveal} style={{ ...revealStyle,transitionDelay:'0.1s' }}>
              {(search ? filteredCats : [FAQ_CATEGORIES[openCat]]).map((cat, ci) => (
                <div key={cat.title}>
                  {search && <div style={{ display:'flex',alignItems:'center',gap:10,marginBottom:16,marginTop:ci>0?32:0 }}><span style={{ fontSize:'1.3rem' }}>{cat.icon}</span><h2 style={{ fontSize:'1.2rem',fontWeight:700 }}>{cat.title}</h2></div>}
                  <div style={{ display:'flex',flexDirection:'column',gap:2 }}>
                    {cat.items.map((item,j) => {
                      const key = `${ci}-${j}`;
                      const open = openItem === key;
                      return (
                        <div key={j} style={{ background:'#fff',borderRadius:'var(--radius-sm)',border:'1px solid var(--border)',overflow:'hidden',transition:'box-shadow 0.2s',...(open?{boxShadow:'0 4px 20px rgba(0,0,0,0.08)'}:{}) }}>
                          <button onClick={() => setOpenItem(open ? null : key)} style={{ width:'100%',display:'flex',alignItems:'center',justifyContent:'space-between',gap:16,padding:'18px 22px',background:'none',border:'none',cursor:'pointer',fontFamily:'inherit',fontSize:'0.95rem',fontWeight:600,color:'var(--text)',textAlign:'left' }}>
                            <span>{item.q}</span>
                            <span style={{ fontSize:'1.2rem',color:'var(--text-muted)',flexShrink:0,transition:'transform 0.3s',transform:open?'rotate(45deg)':'none' }}>+</span>
                          </button>
                          {open && <div style={{ padding:'0 22px 18px',fontSize:'0.9rem',color:'var(--text-muted)',lineHeight:1.7,borderTop:'1px solid var(--border)',paddingTop:16 }}>{item.a}</div>}
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
              {search && filteredCats.length === 0 && (
                <div style={{ textAlign:'center',padding:'60px 20px' }}>
                  <div style={{ fontSize:'2.5rem',marginBottom:16 }}>🔍</div>
                  <h3 style={{ fontSize:'1.2rem',fontWeight:700,marginBottom:8 }}>Nenhum resultado para "{search}"</h3>
                  <p style={{ color:'var(--text-muted)',marginBottom:20 }}>Tente palavras diferentes ou fale com nossa equipe.</p>
                  <a href="/whatsapp" style={{ display:'inline-flex',alignItems:'center',gap:8,padding:'12px 24px',borderRadius:'var(--radius-sm)',background:'var(--accent)',color:'var(--primary)',fontWeight:700,textDecoration:'none',fontSize:'0.9rem' }}>Falar no WhatsApp</a>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

/* ════════════════════════════════════════════════════════════
   PAGE: STATUS
════════════════════════════════════════════════════════════ */
const SERVICES = [
  { name:'Simulador Web', status:'operational', uptime:'99.98%' },
  { name:'API (beta)', status:'operational', uptime:'99.95%' },
  { name:'Exportação PDF', status:'operational', uptime:'99.99%' },
  { name:'Integrações CRM', status:'operational', uptime:'99.91%' },
  { name:'Autenticação', status:'operational', uptime:'100%' },
  { name:'Painel de CRM', status:'operational', uptime:'99.97%' },
];

const STATUS_LABEL = {
  operational: { label:'Operacional', color:'#059669', bg:'rgba(5,150,105,0.1)', dot:'#10B981' },
  degraded:    { label:'Degradado',   color:'#D97706', bg:'rgba(217,119,6,0.1)',  dot:'#F59E0B' },
  incident:    { label:'Incidente',   color:'#DC2626', bg:'rgba(220,38,38,0.1)',  dot:'#EF4444' },
  maintenance: { label:'Manutenção',  color:'#3B82F6', bg:'rgba(59,130,246,0.1)','dot':'#3B82F6' },
};

const INCIDENTS = [
  { date:'20 jan 2026', title:'Lentidão na exportação de PDF', severity:'minor', duration:'18 min', resolved:true, desc:'Um pico de requisições simultâneas causou lentidão na fila de geração de PDF. A fila foi escalada e o problema resolvido às 14:23.' },
  { date:'8 jan 2026', title:'Instabilidade na integração Bitrix24', severity:'minor', duration:'32 min', resolved:true, desc:'Atualização da API do Bitrix24 alterou o formato de resposta de webhooks. Correção aplicada no adaptador de integração.' },
  { date:'15 dez 2025', title:'Manutenção programada — Banco de dados', severity:'maintenance', duration:'45 min', resolved:true, desc:'Manutenção preventiva com migração de índices. Realizada entre 2h–2h45 com impacto mínimo.' },
];

const SEV_COLOR = { minor:'#F59E0B', major:'#EF4444', maintenance:'#3B82F6' };

// Generate 90 days of uptime data (mostly green, a few yellow)
const UPTIME_DAYS = Array.from({ length: 90 }, (_, i) => {
  const rand = Math.random();
  if (rand > 0.97) return 'degraded';
  if (rand > 0.995) return 'incident';
  return 'operational';
});

export function StatusPage() {
  const { addReveal, revealStyle } = useReveal();
  const allOk = SERVICES.every(s => s.status === 'operational');

  return (
    <div className="sb-page">
      <Navbar />

      {/* ── HERO ── */}
      <section style={{ padding:'160px 0 60px',background: allOk ? 'var(--surface)' : '#FEF3C7',position:'relative',overflow:'hidden' }}>
        <div className="container" style={{ textAlign:'center' }}>
          <div ref={addReveal} style={revealStyle}>
            <div style={{ width:80,height:80,borderRadius:'50%',background: allOk ? 'rgba(5,150,105,0.12)' : 'rgba(245,158,11,0.12)',display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 24px',fontSize:'2.2rem' }}>
              {allOk ? '✅' : '⚠️'}
            </div>
            <h1 className="serif page-title" style={{ fontSize:'3rem',marginBottom:16 }}>
              {allOk ? <>Todos os sistemas <em>operacionais</em></> : <>Alguns sistemas com <em>instabilidade</em></>}
            </h1>
            <p style={{ color:'var(--text-muted)',fontSize:'1rem' }}>Última atualização: {new Date().toLocaleString('pt-BR',{timeZone:'America/Sao_Paulo',hour:'2-digit',minute:'2-digit',day:'2-digit',month:'short',year:'numeric'})}</p>
          </div>
        </div>
      </section>

      <section style={{ padding:'60px 0 120px' }}>
        <div className="container" style={{ maxWidth:800 }}>

          {/* Services */}
          <div ref={addReveal} style={{ ...revealStyle,marginBottom:56 }}>
            <h2 style={{ fontSize:'1.2rem',fontWeight:700,marginBottom:20 }}>Status dos serviços</h2>
            <div style={{ display:'flex',flexDirection:'column',gap:2,borderRadius:'var(--radius)',overflow:'hidden',border:'1px solid var(--border)' }}>
              {SERVICES.map((s,i) => {
                const st = STATUS_LABEL[s.status];
                return (
                  <div key={s.name} style={{ padding:'16px 24px',background:'#fff',borderBottom:i<SERVICES.length-1?'1px solid var(--border)':'none',display:'flex',alignItems:'center',justifyContent:'space-between',gap:16 }}>
                    <div style={{ display:'flex',alignItems:'center',gap:12 }}>
                      <div style={{ width:8,height:8,borderRadius:'50%',background:st.dot,animation:s.status==='operational'?'none':'sbPulse 1.5s infinite' }} />
                      <span style={{ fontWeight:500,fontSize:'0.95rem' }}>{s.name}</span>
                    </div>
                    <div style={{ display:'flex',alignItems:'center',gap:20 }}>
                      <span style={{ fontSize:'0.78rem',color:'var(--text-muted)' }}>{s.uptime} uptime</span>
                      <span style={{ fontSize:'0.78rem',fontWeight:700,padding:'3px 10px',borderRadius:100,background:st.bg,color:st.color }}>{st.label}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* 90-day uptime bar */}
          <div ref={addReveal} style={{ ...revealStyle,marginBottom:56 }}>
            <div style={{ display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:12 }}>
              <h2 style={{ fontSize:'1.2rem',fontWeight:700 }}>Uptime — últimos 90 dias</h2>
              <span style={{ fontSize:'0.82rem',color:'var(--text-muted)' }}>99.97% geral</span>
            </div>
            <div style={{ display:'flex',gap:2,height:32,borderRadius:6,overflow:'hidden' }}>
              {UPTIME_DAYS.map((d,i) => (
                <div key={i} title={d} style={{ flex:1,borderRadius:2,background: d==='operational'?'#10B981': d==='degraded'?'#F59E0B':'#EF4444',transition:'opacity 0.2s',cursor:'default' }}
                  onMouseEnter={e => e.target.style.opacity='0.7'} onMouseLeave={e => e.target.style.opacity='1'} />
              ))}
            </div>
            <div style={{ display:'flex',justifyContent:'space-between',marginTop:8,fontSize:'0.75rem',color:'var(--text-muted)' }}>
              <span>90 dias atrás</span><span>Hoje</span>
            </div>
            <div style={{ display:'flex',gap:16,marginTop:10 }}>
              {[['#10B981','Operacional'],['#F59E0B','Degradado'],['#EF4444','Incidente']].map(([c,l]) => (
                <div key={l} style={{ display:'flex',alignItems:'center',gap:6,fontSize:'0.75rem',color:'var(--text-muted)' }}>
                  <div style={{ width:10,height:10,borderRadius:2,background:c }} />{l}
                </div>
              ))}
            </div>
          </div>

          {/* Incidents */}
          <div ref={addReveal} style={revealStyle}>
            <h2 style={{ fontSize:'1.2rem',fontWeight:700,marginBottom:20 }}>Histórico de incidentes</h2>
            <div style={{ display:'flex',flexDirection:'column',gap:16 }}>
              {INCIDENTS.map((inc,i) => (
                <div key={i} style={{ borderRadius:'var(--radius)',border:'1px solid var(--border)',overflow:'hidden' }}>
                  <div style={{ padding:'16px 24px',background:'var(--surface)',display:'flex',alignItems:'center',justifyContent:'space-between',gap:16,flexWrap:'wrap' }}>
                    <div style={{ display:'flex',alignItems:'center',gap:12 }}>
                      <div style={{ width:8,height:8,borderRadius:'50%',background:SEV_COLOR[inc.severity] }} />
                      <span style={{ fontWeight:600,fontSize:'0.95rem' }}>{inc.title}</span>
                    </div>
                    <div style={{ display:'flex',gap:12,alignItems:'center',fontSize:'0.78rem',color:'var(--text-muted)' }}>
                      <span>{inc.date}</span>
                      <span>Duração: {inc.duration}</span>
                      <span style={{ fontWeight:700,color:'#059669',padding:'2px 8px',borderRadius:100,background:'rgba(5,150,105,0.1)' }}>{inc.resolved?'Resolvido':''}</span>
                    </div>
                  </div>
                  <div style={{ padding:'16px 24px',fontSize:'0.88rem',color:'var(--text-muted)',lineHeight:1.65 }}>{inc.desc}</div>
                </div>
              ))}
            </div>
            <div style={{ textAlign:'center',marginTop:28,fontSize:'0.85rem',color:'var(--text-muted)' }}>
              Para ser notificado sobre incidentes, <a href="#" style={{ color:'var(--accent)',textDecoration:'none',fontWeight:600 }}>assine as atualizações de status</a>.
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

/* ════════════════════════════════════════════════════════════
   PAGE: WHATSAPP
════════════════════════════════════════════════════════════ */
const WA_TOPICS = [
  { icon:'🚀', label:'Começar / Trial', msg:'Olá! Gostaria de saber mais sobre o SimulaBank e como testar.' },
  { icon:'💰', label:'Planos e preços', msg:'Olá! Quero entender melhor os planos e preços do SimulaBank.' },
  { icon:'🏦', label:'Dúvida sobre simulação', msg:'Olá! Tenho uma dúvida sobre como funciona a simulação de financiamento.' },
  { icon:'🔗', label:'Integração com CRM', msg:'Olá! Preciso de ajuda para integrar o SimulaBank ao meu CRM.' },
  { icon:'{ }', label:'API e desenvolvimento', msg:'Olá! Tenho interesse na API do SimulaBank.' },
  { icon:'⚙️', label:'Suporte técnico', msg:'Olá! Preciso de suporte técnico sobre o SimulaBank.' },
];
const WA_NUMBER = '5561991826667'; 

export function WhatsAppPage() {
  const { addReveal, revealStyle } = useReveal();
  const [hovered, setHovered] = useState(null);

  const openWA = (msg) => {
    const url = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`;
    window.open(url, '_blank');
  };

  return (
    <div className="sb-page">
      <Navbar />

      {/* ── HERO ── */}
      <section style={{ padding:'160px 0 80px',background:'var(--surface)',position:'relative',overflow:'hidden',textAlign:'center' }}>
        <div style={{ position:'absolute',top:-200,left:'50%',transform:'translateX(-50%)',width:700,height:700,background:'radial-gradient(circle, rgba(37,211,102,0.07) 0%, transparent 65%)',pointerEvents:'none' }} />
        <div className="container" style={{ position:'relative',zIndex:1,maxWidth:600,margin:'0 auto' }}>
          <div ref={addReveal} style={revealStyle}>
            {/* WhatsApp icon animated */}
            <div style={{ width:88,height:88,borderRadius:'50%',background:'#25D366',display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 24px',fontSize:'2.5rem',boxShadow:'0 8px 32px rgba(37,211,102,0.3)',animation:'sbFloat 4s ease-in-out infinite' }}>
              💬
            </div>
            <span className="section-label" style={{ justifyContent:'center' }}>Suporte</span>
            <h1 className="serif page-title" style={{ fontSize:'3rem',marginBottom:16 }}>Fale com a gente no <em>WhatsApp</em></h1>
            <p style={{ color:'var(--text-muted)',fontSize:'1.05rem',marginBottom:12 }}>Nossa equipe responde em até 2 horas em dias úteis.</p>
            <div style={{ display:'inline-flex',alignItems:'center',gap:8,padding:'8px 16px',borderRadius:100,background:'rgba(5,150,105,0.1)',fontSize:'0.82rem',fontWeight:600,color:'#059669' }}>
              <span style={{ width:6,height:6,borderRadius:'50%',background:'#10B981',animation:'sbPulse 2s infinite' }} />
              Online agora — Seg a Sex, 8h às 18h
            </div>
          </div>
        </div>
      </section>

      {/* ── TOPICS ── */}
      <section style={{ padding:'80px 0' }}>
        <div className="container" style={{ maxWidth:700 }}>
          <div ref={addReveal} style={{ ...revealStyle,textAlign:'center',marginBottom:40 }}>
            <h2 className="serif" style={{ fontSize:'2rem',marginBottom:8 }}>Qual é o seu assunto?</h2>
            <p style={{ color:'var(--text-muted)',fontSize:'0.95rem' }}>Escolha um tópico para iniciar uma conversa já direcionada.</p>
          </div>
          <div className="wa-topics-grid">
            {WA_TOPICS.map((t,i) => (
              <button key={t.label} ref={addReveal} className="wa-btn"
                style={{ ...revealStyle,transitionDelay:`${i*0.07}s`,display:'flex',alignItems:'center',gap:16,padding:'20px 24px',background:'#fff',borderRadius:'var(--radius)',border:'1.5px solid var(--border)',cursor:'pointer',fontFamily:'inherit',textAlign:'left',transition:'all 0.2s' }}
                onClick={() => openWA(t.msg)}
                onMouseEnter={e => { e.currentTarget.style.borderColor='#25D366'; e.currentTarget.style.background='rgba(37,211,102,0.04)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor='var(--border)'; e.currentTarget.style.background='#fff'; }}>
                <div style={{ width:44,height:44,borderRadius:10,background:'rgba(37,211,102,0.1)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'1.2rem',flexShrink:0 }}>{t.icon}</div>
                <div>
                  <div style={{ fontWeight:600,fontSize:'0.92rem',color:'var(--text)',marginBottom:2 }}>{t.label}</div>
                  <div style={{ fontSize:'0.78rem',color:'var(--text-muted)' }}>Iniciar conversa →</div>
                </div>
              </button>
            ))}
          </div>

          {/* Direct button */}
          <div ref={addReveal} style={{ ...revealStyle,transitionDelay:'0.4s',textAlign:'center',marginTop:36 }}>
            <p style={{ color:'var(--text-muted)',fontSize:'0.88rem',marginBottom:16 }}>Ou fale diretamente sem selecionar tópico:</p>
            <button className="wa-btn" onClick={() => openWA('Olá! Preciso de ajuda com o SimulaBank.')}
              style={{ display:'inline-flex',alignItems:'center',gap:12,padding:'16px 36px',borderRadius:'var(--radius)',background:'#25D366',color:'#fff',fontWeight:700,fontSize:'1rem',border:'none',cursor:'pointer',fontFamily:'inherit',boxShadow:'0 4px 16px rgba(37,211,102,0.3)' }}>
              <span style={{ fontSize:'1.3rem' }}>💬</span> Abrir WhatsApp
            </button>
            <div style={{ marginTop:12,fontSize:'0.8rem',color:'var(--text-muted)' }}>
              Número: {WA_NUMBER.replace('55', '+55 ').replace(/(\d{2})(\d{5})(\d{4})/, '$1 $2-$3')}
            </div>
          </div>
        </div>
      </section>

      {/* ── OTHER CHANNELS ── */}
      <section style={{ padding:'0 0 100px' }}>
        <div className="container" style={{ maxWidth:700 }}>
          <div ref={addReveal} style={{ ...revealStyle,background:'var(--surface)',borderRadius:'var(--radius)',padding:'36px 40px',border:'1px solid var(--border)' }}>
            <h3 style={{ fontSize:'1.1rem',fontWeight:700,marginBottom:20 }}>Outros canais de suporte</h3>
            <div style={{ display:'flex',flexDirection:'column',gap:0 }}>
              {[
                { icon:'✉️', title:'Email', detail:'suporte@simulabank.com.br', sub:'Respostas em até 1 dia útil', href:'mailto:suporte@simulabank.com.br' },
                { icon:'📚', title:'Central de Ajuda', detail:'Artigos e FAQs', sub:'Respostas instantâneas', href:'/ajuda' },
                { icon:'🟢', title:'Status dos sistemas', detail:'simulabank.com.br/status', sub:'Atualizações em tempo real', href:'/status' },
              ].map((c,i,arr) => (
                <a key={c.title} href={c.href} style={{ display:'flex',alignItems:'center',gap:16,padding:'16px 0',textDecoration:'none',color:'var(--text)',borderBottom:i<arr.length-1?'1px solid var(--border)':'none' }}>
                  <div style={{ width:40,height:40,borderRadius:8,background:'rgba(0,214,143,0.1)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'1.1rem',flexShrink:0 }}>{c.icon}</div>
                  <div style={{ flex:1 }}>
                    <div style={{ fontWeight:600,fontSize:'0.9rem' }}>{c.title}</div>
                    <div style={{ fontSize:'0.8rem',color:'var(--text-muted)' }}>{c.detail} · {c.sub}</div>
                  </div>
                  <span style={{ color:'var(--text-muted)',fontSize:'0.9rem' }}>→</span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}